import { useQuery } from "react-query";
import { getEmailLogs } from "../../../../actions/Utilities/JobConfig";

const useGetEmailLogsByEventId = (args) => {
  return useQuery(["getEmailLogs", args], () => getEmailLogs(args), {
    refetchOnWindowFocus: false,
  });
};
export default useGetEmailLogsByEventId;
